(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2427],{

/***/ 44020:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 39693:
/***/ (function(module) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ 48327:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/[shortname]/funds/[fundShortname]",
      function () {
        return __webpack_require__(65520);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);







var CardTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0;padding-block-end:16px;padding-inline:16px;display:flex;justify-content:space-between;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{padding-inline:0;}"),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                className: "section-title",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0;display:inline-flex;align-items:center;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("h2", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0;font-size:18px;line-height:1.5;letter-spacing:0.02em;"),
                                children: props.children
                            }),
                            props.helpText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props.helpProps), {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin-left:3px;vertical-align:sub;"),
                                children: props.helpText
                            }))
                        ]
                    }),
                    props.sub ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:13px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";margin-left:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                        children: props.sub
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("display:grid;place-items:center;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:13px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";margin-left:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: props.right
                })
            })
        ]
    });
};


/***/ }),

/***/ 44117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96747);



var CheckIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__/* .IcomoonIcon */ .g, {
        name: "check",
        className: props.className
    });
};


/***/ }),

/***/ 53156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ DescriptionList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33869);
/* harmony import */ var _CheckIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44117);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              display: flex;\n              word-break: break-all;\n              font-size: 14px;\n              line-height: 1.3;\n              color: ",
        ";\n              margin-bottom: 0.7rem;\n            "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                flex: 1;\n                font-weight: ",
        ";\n                padding-left: ",
        ";\n                margin-right: ",
        ";\n              "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                flex: 2;\n                white-space: pre-wrap;\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var DescriptionList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("dl", {
        className: props.className,
        children: Object.entries(props.list).filter(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), _ = _param[0], v = _param[1];
            return v.isHidden !== true;
        }).map(function(param, i) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black30 */ .O9.black30),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("dt", {
                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.bold */ .LZ.weight.bold, v.indent && "12px", v.indent && "-12px"),
                        children: [
                            k,
                            v.help && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_3__/* .Help */ .W, {
                                linkTo: v.helpLink,
                                children: v.help
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("dd", {
                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2()),
                        className: v.extraClassName,
                        children: v.bool ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_CheckIcon__WEBPACK_IMPORTED_MODULE_4__/* .CheckIcon */ .n, {}) : v.text
                    })
                ]
            }, i);
        })
    });
};


/***/ }),

/***/ 14792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "cq": function() { return /* binding */ TableHeading; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "pj": function() { return /* binding */ TableCell; },
/* harmony export */   "ss": function() { return /* binding */ TableHead; },
/* harmony export */   "vQ": function() { return /* binding */ SubLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);








var Table = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("table", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        id: props.id,
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{display:block;white-space:nowrap;overflow-x:auto;}background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";width:100%;/* This style is necessary to use sticky header */\n        border-collapse:separate;border-spacing:0;thead{border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray40 */ .O9.gray40, ";border-collapse:collapse;}th,td{border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray50 */ .O9.gray50, ";}th{font-size:13px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";white-space:nowrap;padding:1rem 0.8rem 1rem 0.8rem;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{padding-left:0.5rem;padding-right:0.5rem;}}")
    }, props));
};
var TableHead = function(props) {
    var _offset;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("thead", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("th{position:", props.sticky ? "sticky" : "static", ";top:", (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 0, ";}"),
        "data-test-id": props.dataTestId,
        children: props.children
    });
};
var TableRow = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("tr", {
        css: props.highlightOnHover && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("transition:0.3s;&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white10 */ .O9.white10, ";}"),
        className: props.className,
        "data-appcues": props["data-appcues"],
        children: props.children
    });
};
var TableCell = function(_param) {
    var _omitted = _param.omitted, omitted = _omitted === void 0 ? false : _omitted, _nowrap = _param.nowrap, nowrap = _nowrap === void 0 ? false : _nowrap, _align = _param.align, align = _align === void 0 ? "left" : _align, _vertical = _param.vertical, vertical = _vertical === void 0 ? "top" : _vertical, _centerized = _param.centerized, centerized = _centerized === void 0 ? false : _centerized, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "omitted",
        "nowrap",
        "align",
        "vertical",
        "centerized"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("td", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:14px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black30 */ .O9.black30, ";line-height:1.5;padding:0.8rem;text-align:", centerized ? "center" : align, ";vertical-align:", centerized ? "middle" : vertical, ";", props.width && "width: ".concat(props.width, ";"), " ", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{padding-left:0.5rem;padding-right:0.5rem;}"),
        colSpan: props.colSpan || 1,
        rowSpan: props.rowSpan || 1,
        className: props.className,
        "data-test-id": props.dataTestId,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{white-space:nowrap;}", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{white-space:", nowrap ? "nowrap" : "pre-wrap", ";}", omitted && omittedStyle),
            children: props.empty ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(EmptySymbol, {}) : props.children
        })
    });
};
var EmptySymbol = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("text-align:center;margin-left:25px;"),
        children: "-"
    });
};
var omittedStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("max-height:calc(14px * 1.4 * 3);-webkit-line-clamp:3;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;");
var TableHeading = function(_param) {
    var _align = _param.align, align = _align === void 0 ? "left" : _align, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "align"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("th", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("text-align:", align, ";", props.width && "width: ".concat(props.width, ";")),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;", props.justify && "justify-content: ".concat(props.justify, ";")),
            children: [
                props.children,
                props.sub && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(SubLabel, {
                    children: props.sub
                }),
                props.help && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.helpProps), {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin-left:3px;"),
                    children: props.help
                }))
            ]
        })
    });
};
var SubLabel = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";margin-left:3px;line-height:1.5;"),
        children: "（".concat(props.children, "）")
    });
};


/***/ }),

/***/ 23581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ EmptyCard; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);




var EmptyCard = function(props) {
    var _children;
    var text = (_children = props.children) !== null && _children !== void 0 ? _children : "表示するデータがありません";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card.Content */ .Zb.Content, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
                className: "empty",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("display:flex;align-items:center;justify-content:center;color:#999;font-size:14px;padding:5px;"),
                "data-test-id": props.dataTestId,
                children: text
            })
        })
    });
};


/***/ }),

/***/ 33869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Help; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);





var Help = function(props) {
    var ref;
    if (props.linkTo) {
        var ref1;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
                label: props.children ? (ref1 = props.children) === null || ref1 === void 0 ? void 0 : ref1.toString() : "",
                id: "help",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                    href: props.linkTo,
                    target: "_blank",
                    rel: "noopener",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";vertical-align:middle;&:active,&:visited{color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";}"),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                        text: props.children,
                        className: props.className,
                        size: props.size,
                        offset: props.offset
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
            label: props.children ? (ref = props.children) === null || ref === void 0 ? void 0 : ref.toString() : "",
            id: "help",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                text: props.children,
                className: props.className,
                size: props.size,
                offset: props.offset
            })
        })
    });
};
var Icon = function(props) {
    var ref;
    var offset = "{'top': ".concat(((ref = props.offset) === null || ref === void 0 ? void 0 : ref.top) || 0, "}");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        "data-for": "help",
        "data-offset": offset,
        "data-tip": props.text,
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: "question-circle-fill",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:", props.size === "large" ? "20px" : "14px", ";")
        })
    });
};


/***/ }),

/***/ 31302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ DoubleColumnContent; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);




var DoubleColumnContent = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card.Content */ .Zb.Content, {
        "data-test-id": props["data-test-id"],
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("padding:15px 25px !important;display:flex;flex-direction:column;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{flex-direction:row;> dl{width:50%;&:last-of-type{padding-left:1rem;}}}"),
        children: props.children
    });
};


/***/ }),

/***/ 41181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ toUnitNumber; },
/* harmony export */   "Km": function() { return /* binding */ thousandToMillion; },
/* harmony export */   "dN": function() { return /* binding */ formatAmount; },
/* harmony export */   "ii": function() { return /* binding */ millionToThousand; },
/* harmony export */   "m$": function() { return /* binding */ formatWithComma; }
/* harmony export */ });
/* unused harmony export inThousand */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39693);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_0__);


var formatWithComma = function(n, options) {
    if (n === null || n === undefined) {
        return "";
    }
    var ref = options || {}, _decimalPlace = ref.decimalPlace, decimalPlace = _decimalPlace === void 0 ? 0 : _decimalPlace;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(n.toFixed(decimalPlace).split("."), 2), base = ref1[0], decimalDigits = ref1[1];
    var formatted = base.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return lodash_compact__WEBPACK_IMPORTED_MODULE_0___default()([
        formatted,
        decimalDigits
    ]).join(".");
};
var inThousand = function(n) {
    var numberInThousand = Math.round(n / 1000);
    return formatWithComma(numberInThousand);
};
var millionToThousand = function(i) {
    return i ? i * 1000 : null;
};
var thousandToMillion = function(n) {
    return n ? Number(n * 0.001) : null;
};
var formatAmount = function(n) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        estimated: false
    };
    if (n === null || n === 0) {
        return null;
    }
    if (options.estimated) {
        if (n / 1000 >= 1) {
            return {
                value: "".concat(formatWithComma(thousandToMillion(n))),
                unit: "百万円（推定）"
            };
        }
        return {
            value: "".concat(formatWithComma(n)),
            unit: "千円（推定）"
        };
    } else {
        if (n / 1000 >= 1) {
            return {
                value: "".concat(formatWithComma(thousandToMillion(n))),
                unit: "百万円"
            };
        }
        return {
            value: "".concat(formatWithComma(n)),
            unit: "千円"
        };
    }
};
var toUnitNumber = function(num) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (num >= 1000000000000) return {
        value: divideAndRound(num, 1000000000000, precision),
        unit: "T"
    };
    if (num >= 1000000000) return {
        value: divideAndRound(num, 1000000000, precision),
        unit: "B"
    };
    if (num >= 1000000) return {
        value: divideAndRound(num, 1000000, precision),
        unit: "M"
    };
    if (num >= 1000) return {
        value: divideAndRound(num, 1000, precision),
        unit: "K"
    };
    return {
        value: num,
        unit: null
    };
};
var divideAndRound = function(value, divisionNum, precision) {
    var n = Math.pow(10, precision);
    return Math.floor(value * n / divisionNum) / n;
};


/***/ }),

/***/ 65520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70655);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _components_atoms_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20932);
/* harmony import */ var _components_atoms_CardTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4336);
/* harmony import */ var _components_atoms_CheckIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44117);
/* harmony import */ var _components_atoms_DescriptionList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53156);
/* harmony import */ var _components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14792);
/* harmony import */ var _components_common_Help__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33869);
/* harmony import */ var _components_pages_investor_InvestorTemplate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79181);
/* harmony import */ var _components_pages_investor_DoubleColumnContent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31302);
/* harmony import */ var _components_common_EmptyCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23581);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18584);
/* harmony import */ var _lib_api_investor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70516);
/* harmony import */ var _lib_number__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41181);
/* harmony import */ var _lib_user__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73650);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61753);






















var InvestorFundPage = function(props) {
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_12__/* .useUser */ .a)();
    if (!props.summary || !props.fund) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_error__WEBPACK_IMPORTED_MODULE_16__["default"], {});
    }
    if (!(0,_lib_user__WEBPACK_IMPORTED_MODULE_15__/* .isEnterpriseWithTrial */ .xQ)(user)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_error__WEBPACK_IMPORTED_MODULE_16__["default"], {
            statusCode: 403
        });
    }
    var title = props.fund.unknown ? "ファンド不明" : props.fund.direct ? "直接投資" : props.fund.name;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_components_pages_investor_InvestorTemplate__WEBPACK_IMPORTED_MODULE_9__/* .InvestorTemplate */ .Z, {
        summary: props.summary,
        tab: "funds",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)("position:relative;"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_CardTitle__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .l, {
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)("position:absolute;top:0;right:10px;font-size:16px;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/funds?shortname=".concat(props.summary.shortname),
                    as: "/investors/".concat(props.summary.shortname, "/funds"),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                        href: "/investors/".concat(props.summary.shortname, "/funds"),
                        decoration: "none",
                        children: "一覧に戻る"
                    })
                })
            }),
            !props.fund.direct && !props.fund.unknown && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Zb, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_components_pages_investor_DoubleColumnContent__WEBPACK_IMPORTED_MODULE_10__/* .DoubleColumnContent */ .D, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_DescriptionList__WEBPACK_IMPORTED_MODULE_6__/* .DescriptionList */ .o, {
                            list: {
                                "共同運用者(1)": {
                                    text: props.fund.coInvestors[0] && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                        href: "/investors/".concat(props.fund.coInvestors[0].shortname),
                                        decoration: "none",
                                        children: props.fund.coInvestors[0].name
                                    })
                                },
                                "共同運用者(2)": {
                                    text: props.fund.coInvestors[1] && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                        href: "/investors/".concat(props.fund.coInvestors[1].shortname),
                                        decoration: "none",
                                        children: props.fund.coInvestors[1].name
                                    })
                                },
                                ファンド種別: {
                                    text: props.fund.classification
                                },
                                URL: {
                                    text: props.fund.url && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                        href: props.fund.url,
                                        target: "_blank",
                                        children: props.fund.url
                                    })
                                },
                                "ファンド額(百万円)": {
                                    text: props.fund.amount ? (0,_lib_number__WEBPACK_IMPORTED_MODULE_14__/* .formatWithComma */ .m$)(props.fund.amount) : "",
                                    help: "出資総額"
                                },
                                投資対象: {
                                    text: props.fund.target,
                                    help: "投資エリア、投資期間、ステージ、などファンドの特徴・ユニークな内容"
                                },
                                ファンド類型: {
                                    text: props.fund.type,
                                    help: "地域密着型、汎用型、業種特化型、産学連携型、シードアクセラレーター等"
                                },
                                重点業種: {
                                    text: props.fund.targetIndustry,
                                    help: "ＩＴ関連・バイオ医療ヘルスケア(エネルギーを除く)・エネルギー関連・製品サービス"
                                },
                                重点ステージ: {
                                    text: props.fund.targetStage,
                                    help: "シード・アーリー・エクスパンション・レータ・バランス型・バイアウト型・再生企業"
                                },
                                ファンド背景: {
                                    text: props.fund.background,
                                    help: "ファンドの生れた背景・目的など"
                                },
                                ファンド出資者: {
                                    text: props.fund.financiers
                                },
                                備考: {
                                    text: props.fund.remark
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_DescriptionList__WEBPACK_IMPORTED_MODULE_6__/* .DescriptionList */ .o, {
                            list: {
                                ファンドコード: {
                                    text: props.fund.shortname
                                },
                                ファンド別名旧名: {
                                    text: props.fund.aliasName
                                },
                                開始日: {
                                    text: props.fund.raiseDate,
                                    help: "取扱開始日、設立日、組成予定年月、（日は月末とする）"
                                },
                                "運用期間(年)": {
                                    text: props.fund.term
                                },
                                償還予定年: {
                                    text: props.fund.exitDate
                                },
                                "1社当たりの投資金額": {
                                    text: props.fund.amountPerCompany
                                },
                                "最低出資可能額(千円)": {
                                    text: props.fund.minimumSizeOfInvestment
                                },
                                中小企業基盤整備機構: {
                                    bool: props.fund.chushouJunbi,
                                    help: "中小機構の出資を示す"
                                },
                                産業革新機構: {
                                    bool: props.fund.sangyou,
                                    help: "産業革新機構の出資を示す"
                                },
                                ベンチャーファンド: {
                                    bool: props.fund.ventureFund,
                                    help: "投資対象がベンチャー企業を示す (海外特化型を除く)"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)("padding-top:2rem;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_CardTitle__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .l, {
                        children: "LP情報"
                    }),
                    props.fund.lpDetails.length > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Zb, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .Table */ .iA, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("thead", {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                                                children: "ファンド出資者明細"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                                                children: "分類"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                                                children: "投資家名"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                                                children: "LPファンド"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                                                sub: "百万円",
                                                children: "出資金額"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                                                children: [
                                                    "ファンドオーナー",
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_common_Help__WEBPACK_IMPORTED_MODULE_8__/* .Help */ .W, {
                                                        children: "第三者のVCをGPとし、LPとして参画している二人組合形式ファンドのLPであることを示します。"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("tbody", {
                                    children: props.fund.lpDetails.map(function(lpDetail, i) {
                                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                        href: lpDetail.path,
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                                            href: lpDetail.path,
                                                            decoration: "none",
                                                            children: lpDetail.shortname
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                                    children: lpDetail.investmentType
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                        href: lpDetail.investor.path,
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                                            href: lpDetail.investor.path,
                                                            decoration: "none",
                                                            children: lpDetail.investor.name
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                                    children: lpDetail.lpFund && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                        href: "/investors/".concat(lpDetail.lpFund.investorShortnames[0], "/funds/").concat(lpDetail.lpFund.shortname),
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                                            href: "/investors/".concat(lpDetail.lpFund.investorShortnames[0], "/funds/").concat(lpDetail.lpFund.shortname),
                                                            decoration: "none",
                                                            children: lpDetail.lpFund.name
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                                    children: lpDetail.amount && (0,_lib_number__WEBPACK_IMPORTED_MODULE_14__/* .formatWithComma */ .m$)(lpDetail.amount)
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                                    children: lpDetail.lpOwner && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_CheckIcon__WEBPACK_IMPORTED_MODULE_5__/* .CheckIcon */ .n, {})
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_common_EmptyCard__WEBPACK_IMPORTED_MODULE_11__/* .EmptyCard */ .S, {})
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)("padding-top:2rem;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_CardTitle__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .l, {
                        children: "ラウンド明細 (投資先)"
                    }),
                    props.fund.roundDetails.length > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Zb, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(RoundDetailTable, {
                            roundDetails: props.fund.roundDetails
                        })
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_common_EmptyCard__WEBPACK_IMPORTED_MODULE_11__/* .EmptyCard */ .S, {})
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)("padding-top:2rem;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_CardTitle__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .l, {
                        children: "ラウンド明細 (移動前所有者)"
                    }),
                    props.fund.previousRoundDetails.length > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Zb, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(RoundDetailTable, {
                            roundDetails: props.fund.previousRoundDetails
                        })
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_common_EmptyCard__WEBPACK_IMPORTED_MODULE_11__/* .EmptyCard */ .S, {})
                ]
            })
        ]
    });
};
var RoundDetailTable = function(param) {
    var roundDetails = param.roundDetails;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .Table */ .iA, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("thead", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("tr", {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                            children: "明細行"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                            children: "年月日"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                            children: "スタートアップ"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                            children: "ラウンド"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                            children: "内容"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                            sub: "円",
                            children: "株価"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                            children: "株数"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableHeading */ .cq, {
                            sub: "千円",
                            children: "投資額"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("tbody", {
                children: roundDetails.map(function(roundDetail, i) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("tr", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                    href: roundDetail.path,
                                    decoration: "none",
                                    children: roundDetail.shortname
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                children: roundDetail.roundDate
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                    href: roundDetail.company.path,
                                    decoration: "none",
                                    children: roundDetail.company.name
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                children: roundDetail.type
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                children: roundDetail.investmentDetail
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                children: roundDetail.kabuka
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                children: roundDetail.kabusu
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_atoms_Table__WEBPACK_IMPORTED_MODULE_7__/* .TableCell */ .pj, {
                                children: roundDetail.amount
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
InvestorFundPage.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(ctx) {
        var shortname, fundShortname, investorSummaryResponse, ref, summary, ref1, fund;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    shortname = ctx.query.shortname.toString();
                    fundShortname = ctx.query.fundShortname.toString();
                    return [
                        4,
                        (0,_lib_api_investor__WEBPACK_IMPORTED_MODULE_13__/* .fetchInvestorSummary */ .jM)(ctx, shortname)
                    ];
                case 1:
                    investorSummaryResponse = _state.sent();
                    return [
                        4,
                        Promise.all([
                            investorSummaryResponse === null || investorSummaryResponse === void 0 ? void 0 : investorSummaryResponse.data,
                            (0,_lib_api_investor__WEBPACK_IMPORTED_MODULE_13__/* .getInvestorFund */ .RL)(shortname, fundShortname)
                        ])
                    ];
                case 2:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), summary = ref[0], ref1 = ref[1], fund = ref1.data;
                    return [
                        2,
                        {
                            summary: summary,
                            fund: fund
                        }
                    ];
            }
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (InvestorFundPage);


/***/ }),

/***/ 17563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__(70610);
const decodeComponent = __webpack_require__(44020);
const splitOnFirst = __webpack_require__(80500);

const isNullOrUndefined = value => value === null || value === undefined;

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
			return key => (result, value) => {
				if (value === null || value === undefined || value.length === 0) {
					return result;
				}

				if (result.length === 0) {
					return [[encode(key, options), '=', encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.split('').indexOf(options.arrayFormatSeparator) > -1;
				const newValue = isArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(input, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof input !== 'string') {
		return ret;
	}

	input = input.trim().replace(/^[?#&]/, '');

	if (!input) {
		return ret;
	}

	for (const param of input.split('&')) {
		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (input, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url, hash] = splitOnFirst(input, '#');

	return Object.assign(
		{
			url: url.split('?')[0] || '',
			query: parse(extract(input), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (input, options) => {
	options = Object.assign({
		encode: true,
		strict: true
	}, options);

	const url = removeHash(input.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(input.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, input.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(input.url);
	if (input.fragmentIdentifier) {
		hash = `#${encode(input.fragmentIdentifier, options)}`;
	}

	return `${url}${queryString}${hash}`;
};


/***/ }),

/***/ 80500:
/***/ (function(module) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ 70610:
/***/ (function(module) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8687,519,8674,8101,774,3431,3954,2413,9181,9774,2888,179], function() { return __webpack_exec__(48327); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);